import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './classes/Testimonials.css';
import { configData } from "../config";
import { getGlobalValue } from './PageEditor/globalContentStore';
import { liveCopyOrPlaceholder } from './liveImageFallback';
import { peekServerBlockResponse, takeServerBlockResponse } from './serverPageData';

// The live site sorts the block on the placements' sort numbers alone, and MySQL hands back the
// testimonials that share one number in a different order on every page render: the same cycle,
// started at another item (six uncached loads of /sports-management-bachelors-degree on
// 2026-10-28 began at four different names; the Courses page, whose first three have their own
// numbers, kept those first and varied the rest). So each run of equal numbers is shown from a
// random starting point, as live does, and the numbered ones stay where they are. The server
// lists each testimonial's number as "sort" (a server without it leaves every testimonial tied).
const rotateTies = (list) => {
  const out = [];
  for (let start = 0; start < list.length;) {
    let end = start + 1;
    while (end < list.length && (list[end].sort ?? null) === (list[start].sort ?? null)) end++;
    const run = list.slice(start, end);
    const offset = Math.floor(Math.random() * run.length);
    out.push(...run.slice(offset), ...run.slice(0, offset));
    start = end;
  }
  return out;
};

const Testimonials = ({page}) => {
  const app_url = configData.APP_URL;
  const location = useLocation();
  // On the first screen the server has sent the list with the page's HTML, ties already rotated, in
  // the order the page it sent shows them (serverPageData.js): shown as it is, so the list does not
  // change when this app's page takes the place of the server's
  const [served] = useState(() => (page?.nid ? peekServerBlockResponse('coursepages/gettestimonial', { nid: page.nid }, location.pathname) : null));
  const [content, setContent] = useState(served?.data?.msg === "Success" ? served.data.result : []);
  // The page whose list the server sent, until it has been shown
  const servedNid = useRef(served ? String(page.nid) : null);

useEffect(() => {
    if (page?.nid && servedNid.current === String(page.nid)) {
      // Shown: the server's list is used up
      servedNid.current = null;
      takeServerBlockResponse('coursepages/gettestimonial', { nid: page.nid }, location.pathname);
      return;
    }
    // setContent([
    //   { name: 'Raymond Haija', 
    //     content: 'NFL & CFL Agent', 
    //     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw', 
    //     link: "#", 
    //     position: "Influencer and Affiliate Marketing Manager" },
    //   { name: 'Donovan Phillips', 
    //     content: "I highly recommend SMWW's Athlete Branding and Marketing course. This course afforded me the opportunity to learn from the best...", 
    //     img: 'https://aisiiczsuo.cloudimg.io/v7/https://www.sportsmanagementworldwide.com/sites/default/files/styles/mentor_block_crop/public/pictures/picture-1472-1441814769.jpg?itok=6_KB0Otw', 
    //     link: "#" }
    // ]);
if(page?.nid) {
gettestimonial(page.nid);
}
}, [page]);
const gettestimonial = async (nid) => {
    try {
     
      const postData = {
           nid: nid,
           
          };
          try {
            const response = await fetch(app_url + 'coursepages/gettestimonial', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
              setContent(rotateTies(data.data.result));
            }
          } catch (err) {
             
        }
      
      
    } catch (err) {
      console.error(err);
    }
};
// Some testimonials have no usable picture: the live site's copy of it, else the "not available"
// image instead of a broken one
const placeholderImg = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/person_images/notavailable.jpg';
const showPlaceholder = liveCopyOrPlaceholder(placeholderImg);
// The testimonial's own page, as the live site links it (/testimonial/<name>, or /node/<nid> when it
// has no address of its own). The server may give the stored address without its leading slash,
// which the browser would read as relative to the page (/courses/testimonial/<name>, the home page)
const testimonialHref = (link) => (link ? '/' + String(link).replace(/^\/+/, '') : '');
  // As on the live site, the block is left out when there is nothing to list
  if (!content.length) return null;
  // The id is the live site's block id: some page bodies style it (the London conference's hides it).
  // The picture, the name with the line under it, and the quote side by side in the card, as live
  // lays them out (Testimonials.css); the line is the job line's, which live draws even when empty.
  // The quote is a div: the text comes in its own paragraphs, which a p round it would hold inside.
  return (
    <div id="block-views-testimonials-block" className="course-testimonial-container">
      <h2 className="testimonial-title">{getGlobalValue('testimonials_heading')}</h2>
        <ul>
            {content.map((story, idx) => (<>
                <li key={idx} className="success-box-list">
                  <img src={story.img || placeholderImg} alt={story.title} className="success-img" onError={showPlaceholder} />
                  <div className="testimonial-top-content">
                      {/* No address: the name as plain text, rather than a link to this page */}
                      {testimonialHref(story.link)
                        ? <a href={testimonialHref(story.link)} className="mentor-name-link">{story.title}</a>
                        : <span className="mentor-name-link">{story.title}</span>}
                      <div className="testimonial-position">{story.author_title}</div>
                  </div>
                  <div className="testimonial-quote" dangerouslySetInnerHTML={{
                    __html:story.content
                }}></div>
                </li>
            </>))}
        </ul>

    </div>
  );
};
export default Testimonials;